import { render, staticRenderFns } from "./statementLst.vue?vue&type=template&id=48589f01&scoped=true&"
import script from "./statementLst.vue?vue&type=script&lang=js&"
export * from "./statementLst.vue?vue&type=script&lang=js&"
import style0 from "./statementLst.vue?vue&type=style&index=0&id=48589f01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48589f01",
  null
  
)

export default component.exports